import { useState } from "react";
import { List, ListItemButton, ListItemText, ChildList } from "./list";
import { Collapse, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const Menu = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isUpMd = useMediaQuery('(min-width: 900px)');

  return <List>
    {(isUpMd ? items : [{ label: 'Select', children: items }]).map((item) => item.children ? (
      <CollapsibleMenu key={item.label} label={item.label} items={item.children} />
    ) : (
        <ListItemButton key={item.label} onClick={() => navigate(item.path)} selected={location.pathname === item.path}>
          <ListItemText primary={item.label} />
        </ListItemButton>
    ))}
  </List>
}

const CollapsibleMenu = ({ items, label }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return <>
    <ListItemButton onClick={() => setOpen(!open)}>
      <ListItemText primary={label} />
      {open ? <ExpandLess sx={{ color: "#1E1E1E", width: "24px", height: "24px", paddingRight: "15px" }} /> : <ExpandMore sx={{ color: "#1E1E1E", width: "24px", height: "24px", paddingRight: "15px" }} />}
    </ListItemButton>
    {items.length > 0 ? <Collapse in={open} timeout="auto" unmountOnExit>
      <ChildList component="div">
        {items.map((item) => (
          <ListItemButton key={item.label} sx={{ pl: 4 }} selected={location.pathname === item.path} onClick={() => navigate(item.path)}>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </ChildList>
    </Collapse> : null}
  </>
}

export default Menu;